import {Injectable} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";

import {DialogConfirmComponent} from "../components/dialogs/dialog-confirm/dialog-confirm.component";
import {map, Observable} from "rxjs";
import {
  DialogTemplatesChoiceComponent
} from "../components/dialogs/dialog-templates-choice/dialog-templates-choice.component";
import {
  DialogCreateTemplateComponent
} from "../components/dialogs/dialog-create-template/dialog-create-template.component";
import {DialogLoaderComponent} from "../components/dialogs/dialog-loader/dialog-loader.component";
import {TableColumn} from "daisy-design-system-front";
import {ExportRequestChildComponent} from "../components/export-request-child/export-request-child.component";
import {DialogService as PrimeNgDialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {
  DialogExportRequestTagsComponent
} from '../components/export-request/ontology-writer/tag-writer/dialog-export-request-tags/dialog-export-request-tags.component';
import {FormGroup} from "@angular/forms";
import {OntologyFormType} from "@gnv-shared/types";
import {MappedExportTemplate} from '../../models/export-templates/export-template.models';
import {
  UploadDialogParam,
  UploadDialogResponseParam
} from '../components/dialogs/dialog-create-template/models/upload-dialog.models';
import {
  DialogConfirmStationsDisplayComponent
} from '../components/dialogs/dialog-confirm-stations-display/dialog-confirm-stations-display.component';

@Injectable({
  providedIn: "root",
})
export class DialogService {
  ref: DynamicDialogRef | undefined;

  constructor(
    private dialog: MatDialog,
    public readonly pDialogService: PrimeNgDialogService
  ) {
  }

  public openSelectTemplatesDialog(): Observable<{
    selectedModel: MappedExportTemplate;
    createNewTemplate: boolean;
  }> {
    return this.dialog
      .open(DialogTemplatesChoiceComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: "custom-mat-dialog",
      })
      .afterClosed()
      .pipe(
        map((response) => ({
          selectedModel: response.selectedModel,
          createNewTemplate: response.createNewTemplate,
        }))
      );
  }

  public openCreateTemplatesDialog(param?: UploadDialogParam): Observable<UploadDialogResponseParam> {
    return this.dialog
      .open(DialogCreateTemplateComponent, {
        data: param,
        closeOnNavigation: false,
        disableClose: true,
        panelClass: "custom-mat-dialog",
      })
      .afterClosed();
  }

  public openLoader(message: string) {
    return this.dialog.open(DialogLoaderComponent, {
      data: { message },
      closeOnNavigation: false,
      disableClose: true,
      hasBackdrop: false,
      panelClass: 'loader-dialog-top'
    });
  }

  openChildrenView(param: { parentId: string; parentNam: string, tableColumns: TableColumn[] }) {
    this.ref = this.pDialogService.open(ExportRequestChildComponent, {
      header: param.parentNam,
      width: "50vw",
      contentStyle: { overflow: "auto" },
      data: param,
      height: '50vh',
      modal: true,
      maximizable: true,
      closable: true,
    });
  }

  public openConfirm(param: {
    message: string;
    yesButtonLabel?: string;
    noButtonLabel?: string;
  }): Observable<{ accept: boolean }> {

    return this.pDialogService.open(DialogConfirmComponent, {
      header: '',
      contentStyle: { overflow: "auto" },
      data: param,
      closable: false,
      modal: true,
      appendTo: 'body',
    })
      .onClose
      .pipe(map((response) => ({ accept: response.accept })));
  }

  public openConfirmStationDisplay(checked: boolean): Observable<{ accept: boolean }> {
    return this.pDialogService.open(DialogConfirmStationsDisplayComponent, {
      header: '',
      contentStyle: { overflow: "auto" },
      data: { checked },
      closable: false,
      modal: true,
      appendTo: 'body',
    })
      .onClose
      .pipe(map((response) => ({ accept: response.accept })));
  }

  openTagsView(param: { stationUid: string, stationName: string, valueFormGroup: FormGroup<OntologyFormType> }) {
    return this.pDialogService.open(DialogExportRequestTagsComponent, {
      header: param?.stationName,
      width: "50vw",
      contentStyle: { overflow: "auto" },
      data: param,
      height: '80%',
      modal: true,
      maximizable: true,
      closable: true,
    })
      .onClose;
  }

}

